function formatNumber(number: number, language = 'de-DE'): string {
    return Intl.NumberFormat(language).format(number);
}

export default formatNumber;
